import React, { useContext, useEffect, Fragment } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import Utility from './Utility';
import UtilitySeller from './UtilitySeller';
import AlertNotAuthorized from '../../Complements/AlertNotAuthorized';

export default function UtilityIndex() {
   //Extraer la informacion de autenticación
   const authContext = useContext(AuthContext);
   const { usuario, usuarioAutenticado } = authContext;

   useEffect(() => {
    usuarioAutenticado();
  }, []);

  let component;
  if(usuario){
    switch (usuario.type) {
		case '1':
			component = <Utility />
			break;
		case '2':
			component = <UtilitySeller usuario={usuario} />
			break;
		case '3':
			component = <UtilitySeller usuario={usuario} />
			break;
		default:
			component = <AlertNotAuthorized mensaje={"No tienes los suficientes permisos para ver esta página"}/>
			break;
    }
  }
  return (
    <Fragment>
      {component}
    </Fragment>
  )
}
